<template>
  <v-container grid-list-lg>
    <v-layout row wrap v-if="false"> 
      <v-flex xs12>
        <v-carousel style="cursor: pointer">
          <v-carousel-item v-for="campeonato in campeonatos"
            :src="campeonato.imURL"
            :key = "campeonato.imID"
            @click="onLoadTournaments(campeonato.imID)"
          >
            <div class="title">
              {{campeonato.title}}
            </div>
          </v-carousel-item>
        </v-carousel>
        <v-card>
          
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="false" class="mt-2">
      <v-flex xs12 class="text-xs-center">
        <h4>{{ $t("home_page.mission") }}</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="false">
      <v-flex xs12 sm6 class="text-xs-center">
        <v-btn large router to="/campeonatos" class="primary">{{ $tc("championship", 2) }}</v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-center">
        <v-btn large router to="/campeonatos/novo" class="primary">Criar Campeonato</v-btn>
      </v-flex>
    </v-layout>
    <v-card color="primary" style="border-radius:12px; cursor:pointer" to="/campeonatos" height="200px" class="my-3">
      <v-img aspect-ratio="2" height="200" :src="img_champs">
        <div class="white--text text-xs-center display-1 evidence mb-0">{{($t('championships')).toUpperCase()}}</div>
      </v-img>
    </v-card>
    <v-card color="primary" style="border-radius:12px; cursor:pointer" to="/campeonatos/novo" height="200px" class="my-3">
      <v-img aspect-ratio="2.75" height="200" :src="img_new_champ">
        <div class="white--text text-xs-center display-1 evidence mb-0">{{($t('create_championship')).toUpperCase()}}</div>
      </v-img>
    </v-card>
  </v-container>
</template>

<script>
import AllChampshioshipsBG from '../../public/img/background/all_champs.jpeg'
import NewChampshioshipBG from '../../public/img/background/new_champ.jpeg'

export default {
  data () {
    return {
      campeonatos: [
        {title: 'Copa União', imURL: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQk0hwrLzyD-rXXvoxesW3sud_fjjiQ37xKVLmFJN5M6Ksg49XS', imID: '1'},
        {title: 'Copa Camisa 10', imURL: 'https://i1.wp.com/media.sistemampa.com.br/2018/02/WhatsApp-Image-2018-02-26-at-21.12.35.jpeg?resize=700%2C700&ssl=1', imID: '2'},
      ],
      img_champs: AllChampshioshipsBG, //'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
      img_new_champ: NewChampshioshipBG //'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
    }
  },
  methods: {
    onLoadTournaments(id){
      this.$router.push('/campeonatos/' + id)
    }
  }

  }
</script>

<style scoped>
.title{
  position: absolute;
  bottom: 50px;
  background-color: rgba(0,0,0,0.5);
  color: white;
  font-size: 2em;
  padding: 20px;
}

.evidence{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>